// Raster timing derived from the Galaxian/Frogger hardware. Other values are
// independent calibrations; see ARCADE_FIDELITY.md, not recovered ROM constants.
export const WIDTH = 224;
export const HEIGHT = 256;
export const SIM_HZ = 2000 / 33;
export const STEP_SECONDS = 1 / SIM_HZ;
export const HOP = 16;
export const HOP_FRAMES = 8;
export const START_X = 112;
export const START_Y = 232;
export const HOME_Y = 40;
export const HOME_X = [16, 64, 112, 160, 208] as const;
export const BEATS = 60;
export const FRAMES_PER_BEAT = 32;
export const TIMING = { ready: 45, death: 58, home: 42, level: 115 } as const;
export const rowY = (row: number): number => START_Y - row * HOP;
export const yRow = (y: number): number => Math.round((START_Y - y) / HOP);
